import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "px-8 grid grid-cols-12 gap-5 py-8 h-full items-center container mx-auto" }
const _hoisted_2 = { class: "col-span-12 md:col-span-6 text-center md:text-start text-white" }
const _hoisted_3 = { class: "mb-3 flex items-center gap-5" }
const _hoisted_4 = { class: "ml-2 hidden sm:block" }
const _hoisted_5 = { class: "text-md mb-3 text-gray-300" }
const _hoisted_6 = {
  key: 0,
  class: "bg-h-warning-100 text-h-warning-700 rounded-md shadow-sm flex gap-2 p-2 mt-5 w-fit"
}
const _hoisted_7 = { class: "col-span-12 md:col-span-6" }
const _hoisted_8 = { class: "hidden justify-center md:justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", {
    class: "bg-gray-800 bg-no-repeat bg-cover bg-center select-none h-72",
    style: _normalizeStyle(_ctx.backgroundImage(_ctx.course?.file?.url))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.course?.name) + " ", 1),
          (_ctx.role == 'TEACHER')
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "btn-outline-white p-button-sm h-10",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go.redirectToPage('formCourse', { id: _ctx.course?.id })))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    name: "hi-solid-pencil",
                    class: "cursor-pointer hover:scale-125 transition-all"
                  }),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Editar",
                  en: "Edit",
                })), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.course?.description), 1),
        (_ctx.user.teacherProfile === null && _ctx.role == 'TEACHER')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_v_icon, { name: "md-warningamber-round" }),
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
                pt: "Lembre-se de adicionar a sua biografia e os seus títulos,",
                en: "Remember to add your biography and titles,",
              })) + " ", 1),
                _createVNode(_component_router_link, {
                  to: { name: 'editUser' },
                  class: "font-bold"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", { pt: "clique aqui.", en: "click here." })), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.course?.status == 'APPROVED')
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "Publicar curso",
                class: "btn-primary p-button-sm",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.courseGenerics.publishCourse(_ctx.course?.id)))
              }))
            : _createCommentVNode("", true),
          (_ctx.course?.status == 'NOT_PUBLISHED')
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                label: "Enviar para aprovação",
                class: "btn-light p-button-sm",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (
              _ctx.courseGenerics.sendToApprove(
                _ctx.course?.id,
                _ctx.course.type === 'INTERACTIVE' ? '/api' : '/graphs'
              )
            ))
              }))
            : _createCommentVNode("", true),
          (_ctx.course?.status == 'WAITING')
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                label: "Aguardando aprovação",
                class: "btn-outline p-button-sm",
                disabled: true
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 4))
}